import React from 'react';
import $ from 'jquery';
import {Link} from 'react-router-dom';
import Meta from '../model/Meta';

const NotFound = (props)=>{

	$('html, body').animate({scrollTop: 0}, 300);
	
	const meta = {
		title: "404: Page not found",
		description: "You are looking for a page that doest exist of permanently deleted."
	}
    
	return (
		<div className="page page-inner not-found pb-5">
			<Meta {...meta}/>
			<div className="container-fluid">
				<div className="container p-0">
					<h1 className="page-title">404</h1>
					<div className="page-content">
						<p>You are looking for a page that doesn't exist or permanently deleted.</p>
						<p><Link to="/">Go to Homepage</Link></p>
					</div>
				</div>
			</div>
		</div>
	);
}

export default NotFound;


// WEBPACK FOOTER //
// ./src/pages/NotFound.js